import { render, staticRenderFns } from "./Robot.vue?vue&type=template&id=f3c6db8c&scoped=true&"
import script from "./Robot.vue?vue&type=script&lang=js&"
export * from "./Robot.vue?vue&type=script&lang=js&"
import style0 from "./Robot.vue?vue&type=style&index=0&id=f3c6db8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c6db8c",
  null
  
)

component.options.__file = "Robot.vue"
export default component.exports